export default function (context) {
  if (context.from) {
    if (window.tempDataLayer && window.tempDataLayer.length > 0) {
      setTimeout(context.$flushTempDataLayer, 30);
    }
  }
}
